import NarrowSecureLayout from "../../../layout/NarrowSecureLayout.jsx";
import {useTranslation} from "react-i18next";
import CreateIntegrationPlatform from "./CreateIntegrationPlatform.jsx";
import {useState} from "react";
import ThirdPartyServiceEditForm from "./ThirdPartyServiceEditForm.jsx";
import BrandLogo from "../../../utils/brands/BrandLogo.jsx";
import PageTitle from "../../../components/PageTitle.jsx";
import {isPreview} from "../../../utils/environment.js";
import {useAdSystemBrands, useErpBrands, useGoogleDataBrands, useLeadBrands} from "../../../utils/brands/branding.js";
import SupportLink from "../../../components/SupportLink.jsx";
import Button from "../../../components/Button.jsx";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";

export default function CreateIntegrationChoosePlatform({project}) {

    let {t} = useTranslation();
    let navigate = useNavigate();

    const [brand, setBrand] = useState(null);

    let adSystemIntegrations = useAdSystemBrands();

    let erpIntegrations = useErpBrands();
    let leadIntegrations = useLeadBrands();
    let googleDataIntegrations = useGoogleDataBrands();

    if (brand !== null) {
        return <NarrowSecureLayout
            title={<div className={'inline-flex gap-3'}>
                <BrandLogo brand={brand} className={'mx-aut my-auto'}/>
                <div className={'mx-aut my-auto'}>{brand.name}</div>
            </div>}
            actions={<>
                <Button
                    variant={'outline-primary'}
                    onClick={() => setBrand(null)}
                >
                    <span className={'inline-flex items-center gap-2'}>
                        <FontAwesomeIcon icon={faArrowLeft}/>
                        <span>{t('project.back-to-integrations', {defaultValue: 'Zpět'})}</span>
                    </span>
                </Button>
                {brand.helpArticleId &&
                    <SupportLink
                        articleId={brand.helpArticleId}
                        title={t('support.help-for-integration', {integrationName: brand.name})
                        }/>
                }
            </>}
        >
            <ThirdPartyServiceEditForm project={project} brand={brand} projectIntegration={null}/>
        </NarrowSecureLayout>;
    }

    if (isPreview()) {
        return <NarrowSecureLayout>
            <PageTitle>{t('error.endpoint-not-allowed-on-demo')}</PageTitle>
        </NarrowSecureLayout>;
    }

    if (!project.hasErpIntegration && !project.hasLeadIntegration) {
        return <NarrowSecureLayout>
            <PageTitle>{t('project.create-shop-or-lead-system')}</PageTitle>
            {t('project.this-cannot-be-changed-later')}

            <div className={'flex flex-wrap gap-3 py-6'}>
                {erpIntegrations.length > 0 && erpIntegrations.map((brand) => {
                    return <CreateIntegrationPlatform
                        brand={brand}
                        key={brand.slug}
                        onClick={() => setBrand(brand)}
                    />;
                })}

                {leadIntegrations.length > 0 && leadIntegrations.map((brand) => {
                    return <CreateIntegrationPlatform
                        brand={brand}
                        key={brand.slug}
                        onClick={() => setBrand(brand)}
                    />;
                })}
            </div>

        </NarrowSecureLayout>;
    }

    return <NarrowSecureLayout
        title={t('project.add-integration', {defaultValue: 'Přidat integraci'})}
        actions={<Button
            variant={'outline-primary'}
            onClick={() => navigate('/project/' + project.id + '/settings/integrations')}
        >
            <span className={'inline-flex items-center gap-2'}>
                <FontAwesomeIcon icon={faArrowLeft}/>
                <span>{t('project.back-to-integrations', {defaultValue: 'Zpět'})}</span>
            </span>
        </Button>}
    >
        <div className={'text-xl text-slate-800 dark:text-white mt-2'}>
            {t('project.integration-category.marketing', {defaultValue: 'Marketingové integrace'})}
        </div>
        <div className={'flex flex-wrap gap-3 py-6'}>
            {adSystemIntegrations.length > 0 ? adSystemIntegrations.map((brand) => {
                return <CreateIntegrationPlatform
                    brand={brand}
                    key={brand.slug}
                    onClick={() => setBrand(brand)}
                />;
            }) : t('project.no-integration-for-this-category')}
        </div>
        {googleDataIntegrations.length > 0 && <>
            <div className={'text-xl text-slate-800 dark:text-white mt-6'}>
                {t('project.integration-category.data-and-analytics', {defaultValue: 'Datové a analytické integrace'})}
            </div>
            <div className={'flex flex-wrap gap-3 py-6'}>
                {googleDataIntegrations.map((brand) => <CreateIntegrationPlatform
                    brand={brand}
                    key={brand.slug}
                    onClick={() => setBrand(brand)}
                />)}
            </div>
        </>}
    </NarrowSecureLayout>;
}
